import { PATH_DASHBOARD } from 'src/routes/paths';

/**
 * Shared tour step shown only to free users at the end of tours.
 * Used across multiple tour configs (settings, rescues, partnerships, donations, etc.)
 * so copy and behavior can be updated in one place.
 */
export const freeUserUpgradeStep = {
  title: 'tours.upgrade.title',
  content: 'tours.upgrade.content',
  contentValues: { url: PATH_DASHBOARD.allPlans },
  placement: 'center',
  showIf: (discriminators) => discriminators?.plan === 'free',
};
